	export enum ClaimCreationStatusEnum {
		Success = 1,
		ActionRequired = 2,
		Error = 3
	}
